import { Button } from '@/components/ui/Button';

export interface EmailSuggestionProps {
  suggestion: string;
  typed: string;
  onUse: () => void;
  /** Omit for a hard refusal: the typed address cannot be kept. */
  onKeep?: () => void;
  /** DOM id prefix; the block is `{idPrefix}.suggestion`. */
  idPrefix: string;
  disabled?: boolean;
}

/** Inline "Did you mean x?" prompt shown under an address field at submit time. */
export function EmailSuggestion({
  suggestion,
  typed,
  onUse,
  onKeep,
  idPrefix,
  disabled,
}: EmailSuggestionProps) {
  const id = `${idPrefix}.suggestion`;
  return (
    <div
      id={id}
      role="status"
      className="space-y-2 rounded-lg border border-amber-300 bg-amber-50 p-3 dark:border-amber-500/40 dark:bg-amber-500/10"
    >
      <p className="text-sm text-gray-900 dark:text-white">
        Did you mean{' '}
        <strong id={`${id}.address`} className="font-semibold">
          {suggestion}
        </strong>
        ?
      </p>
      <div className="flex flex-wrap gap-2">
        <Button
          id={`${id}.use`}
          type="button"
          size="sm"
          disabled={disabled}
          onClick={onUse}
        >
          Use {suggestion}
        </Button>
        {onKeep ? (
          <Button
            id={`${id}.keep`}
            type="button"
            size="sm"
            variant="outline"
            disabled={disabled}
            onClick={onKeep}
          >
            Keep {typed}
          </Button>
        ) : null}
      </div>
    </div>
  );
}
